import request from '@/utils/request';
import store from '@/store';
export function getFileInfo(linkUrl, params) {
  var extensionsUrl = linkUrl && linkUrl.extensions ? linkUrl.extensions : store.state.app.linkUrl.extensions;
  return request({
    // url: '/package/banner/upload/file-allow-extensions',
    url: extensionsUrl,
    method: 'get',
    params: params
  });
}